//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getintouch from '../components/modals/GetInTouch';

export default {
	components: {
		getintouch
	},
	data () {
		return {
			name:'Home',
			ui: {
				modals: {
					getInTouch: {
						shown: false
					}
				}
			}
		}
	},
	methods: {
		initMessenger() {
		},
		getInTouch() {
			this.ui.modals.getInTouch.shown = true;
		},
		onDismissed() {
			this.ui.modals.getInTouch.shown = false;
		}
	},
	computed: {
		timeOfDayGreeting() {
			let hrs = new Date().getHours();

			let greet;

			if (hrs < 12) {
				greet = 'Good Morning';
			}
			else if (hrs >= 12 && hrs <= 17) {
				greet = 'Good Afternoon';
			}
			else if (hrs >= 17 && hrs <= 24) {
				greet = 'Good Evening';
			}

			return greet;
		}
	},
	mounted() {
		/*
		this.$fbCustomerChat.setOptions({
			theme_color: '#0499CF'
		})
		*/

		this.$nextTick(() => {
			

		});

		
	}
}
